export default "__VITE_ASSET__Cc$39fsr__"